import { useEffect } from "react";
import { CheckoutInfoResponse } from "../../../types/CheckoutInfoResponse";

type EWalletProps = {
  getCheckoutInfoData: CheckoutInfoResponse;
};

const PkKaroRedirectMode = ({ getCheckoutInfoData }: EWalletProps) => {
  useEffect(() => {
    if (getCheckoutInfoData && getCheckoutInfoData.qrcodeUrl) {
      window.location.href = getCheckoutInfoData.qrcodeUrl;
    }
  }, [getCheckoutInfoData]);
  return <></>;
};

export default PkKaroRedirectMode;
